import { render, staticRenderFns } from "./SwitchingContact.vue?vue&type=template&id=a20c44ac"
import script from "./SwitchingContact.vue?vue&type=script&lang=js"
export * from "./SwitchingContact.vue?vue&type=script&lang=js"
import style0 from "./SwitchingContact.vue?vue&type=style&index=0&id=a20c44ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports